import { ShapeType } from "../../../types/Enum";


export default function getOffsets(shapeType: ShapeType): number[] {
  let offsets = [1, 1, 3, 3];
  if(shapeType == ShapeType.parallel || shapeType == ShapeType.trapezoid) {
    offsets = [1, 1, 4, 3];
  } else if(shapeType == ShapeType.triangle) {
    offsets = [ 2, 2, 2, 3];
  }
  return offsets;
}